var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.875 1.5C18.5319 1.5 19.875 2.84315 19.875 4.5V19.5C19.875 21.1569 18.5319 22.5 16.875 22.5H7.125C5.46815 22.5 4.125 21.1569 4.125 19.5V4.5C4.125 2.84315 5.46815 1.5 7.125 1.5H16.875ZM7.125 3C6.29657 3 5.625 3.67157 5.625 4.5V19.5C5.625 20.3284 6.29657 21 7.125 21H16.875C17.7034 21 18.375 20.3284 18.375 19.5V4.5C18.375 3.67157 17.7034 3 16.875 3H7.125ZM12 15.8994C12.7247 15.8994 13.3122 16.4873 13.3125 17.2119C13.3125 17.9368 12.7249 18.5244 12 18.5244C11.2751 18.5244 10.6875 17.9368 10.6875 17.2119C10.6878 16.4873 11.2753 15.8994 12 15.8994Z",
    fill: "#FC4C02"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/Phone.60a3a3eb04283503624a771dbc384132.svg";
export { ForwardRef as ReactComponent };